import {Controller} from "@hotwired/stimulus"
import Debug from 'debug';

type OpenParams = {
    id?: string,
    src: string,
    contentGrow?: boolean
}

declare global {
    interface Window {
        modalFrame: (params: OpenParams) => void
    }
}

export const name = 'modal-frame';
const debug = Debug(`app:${name}`);

export default class ModalFrameController extends Controller {

    static targets = ["dialog", "frame", 'contentWrapper']
    static values = {
        open: Boolean,
    }

    declare dialogTarget: HTMLDialogElement;
    declare frameTarget: HTMLIFrameElement;
    declare contentWrapperTarget: HTMLDivElement;

    declare openValue: boolean;

    connect() {
        debug('connect');
        window.modalFrame = (params) => {
            this.openEvent(params);
        }
        if (this.openValue) this.open();
        document.addEventListener("turbo:before-cache", this.beforeCache);
    }

    disconnect() {
        document.removeEventListener("turbo:before-cache", this.beforeCache);
    }

    openEvent = ({id, src, contentGrow}: OpenParams) => {
        debug('openEvent', id, src);
        console.log("openEvent");
        this.frameTarget.src = src;
        this.frameTarget.id = id ?? 'mft';

        if (contentGrow) {
            this.contentWrapperTarget.classList.add('grow');
        }

        this.open();
    }

    open() {
        this.dialogTarget.showModal()
    }

    // Allows for a closing animation since display transitions don't work yet
    close() {
        this.dialogTarget.setAttribute("closing", "")

        Promise.all(
            this.dialogTarget.getAnimations().map((animation) => animation.finished),
        ).then(() => {
            this.dialogTarget.removeAttribute("closing")
            this.dialogTarget.close()
            this.frameTarget.innerHTML = '';
            this.contentWrapperTarget.classList.remove('grow');
        })
    }

    backdropClose(event) {
        if (event.target.nodeName == "DIALOG") this.close()
    }

    // For showing non-modally
    show() {
        this.dialogTarget.show()
    }

    hide() {
        this.close()
    }

    beforeCache = () => {
        this.close()
    }
}